import graphql__19e06ccdf9ec797d172a from "./__generated__/TranscribeAudioMutation.graphql.js";import { commitMutation, graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__19e06ccdf9ec797d172a;

function transcribeAudio(
  variables,
  onCompleted,
  onError = error => console.error(error)
) {
  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError
  });
}

export { transcribeAudio };
